import { Pipe, PipeTransform } from '@angular/core';
import { CustomFileModel } from '../models/entities/file.type';

@Pipe({
  name: 'findFileById'
})
export class FindFileByIdPipe implements PipeTransform {

  transform(files: CustomFileModel[], fileId: string): CustomFileModel {
    if (!files || !fileId) {
      return null;
    }

    return files.find(file => file.Id === fileId);
  }

}
